import gql from 'graphql-tag';

export const BULK_UNPUBLISH_PROPERTIES = gql`
  mutation bulkUnpublishProperties($input: BulkUnpublishPropertiesInput!) {
    bulkUnpublishProperties(input: $input) {
      error
      status
      invalidUnpublishedProperties {
        id
        propertyName
      }
    }
  }
`;
